export default __webpack_public_path__ + "static/media/Banner_Landing Reconocimientos_Ampliación_.49abeb6b.png";